import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { LevelOfServiceService } from "../service/level-of-service.service";
import { imageProcessing } from "src/app/utils/image-processing-utils";
import { ProTipsServiceService } from "../../helping-material/nemt-pro-tips/service/pro-tips-service.service";

@Component({
  selector: "app-add-level-of-service",
  templateUrl: "./add-level-of-service.component.html",
  styleUrls: ["./add-level-of-service.component.css"],
})
export class AddLevelOfServiceComponent implements OnInit {
  levelOfServiceForm: FormGroup;
  submitted = false;
  userId = null;
  levelOfServiceId;
 
  constructor(
    public authService: AuthService,
    private levelOfServiceService: LevelOfServiceService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private proTips: ProTipsServiceService
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.levelOfServiceId = params["id"];
      if(this.levelOfServiceId){
        this.getLevelOfServicebyId();
      }
    });

    this.levelOfServiceForm = this.fb.group({
      title: ["", Validators.required],
      status: ['active', Validators.required],
      description: [""],
      profileImageURL : ["", Validators.required]
    });
  }

  getLevelOfServicebyId(){
    this.levelOfServiceService.getLevelOfServicebyId(this.levelOfServiceId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.levelOfServiceForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  saveLevelOfService() {
    this.submitted = true;
    if (this.levelOfServiceForm.invalid) {
      return;
    }
      let payload = this.levelOfServiceForm.value;
      this.levelOfServiceService.saveLevelOfService(this.levelOfServiceId,payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/levelofservice");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
     .subscribe(async (result) => {
      const data:any =  await this.proTips.changeCoverImage(result.file).toPromise();
      form.setValue(data.location);
    })
  
    }
  get form() {
    return this.levelOfServiceForm.controls;
  }

  ngOnDestroy(): void {
  }
}
